import { Theme } from "@mui/material/styles";
import { alpha, SystemStyleObject } from "@mui/system";

const infoServicesStyles = {
  image: (theme: Theme): SystemStyleObject<Theme> => ({
    "& > div > span": {
      filter: `drop-shadow(0 -25px 32px ${alpha(
        theme.palette.secondary.main,
        0.75,
      )})`,
    },
  }),
};

export default infoServicesStyles;
